import FadeInImage from 'components/FadeInImage';
import { SET_PROFILE_LAYOUT_TYPE } from 'containers/ProfileManager/redux/profile.types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import './style.scss';

export const ProfileImageOption = ({ profileImg, onOptionClick }) => {
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const {
    home_anonymous_placeholder_img,
    avatarSelector_access_option_button_RightNavegation,
  } = useSelector(state => state.asset);

  const handleOptionClick = () => {
    onOptionClick && onOptionClick();
    dispatch({
      type: SET_PROFILE_LAYOUT_TYPE,
      payload: 'SELECT_PROFILE_IMAGE',
    });
  };

  return (
    <div className="profile-image-option" onClick={handleOptionClick}>
      <div className="profile-image-option__caption">
        <FadeInImage
          imageSrc={profileImg ? profileImg : home_anonymous_placeholder_img}
          width={57}
          height={57}
          classNames={['profile-image-option__caption__img']}
        />
        <span className="profile-image-option__caption__label">
          {getTranslation(
            'addProfile_access_option_button_avatarSelector',
            translations,
          )}
        </span>
      </div>
      <FadeInImage
        imageSrc={avatarSelector_access_option_button_RightNavegation}
        width={58}
        height={58}
        classNames={['profile-image-option__arrow']}
      />
    </div>
  );
};
